import * as React from "react";
import { Popover, IconButton, Box } from "@mui/material";
import { AccountAvatar } from "../AccountAvatar/accountAvatar";
import { LoginButton } from "../AuthComponents/LoginButton";
import { LogoutButton } from "../AuthComponents/LogoutButton";
import { useAuth0 } from "@auth0/auth0-react";

type AnchorEl = HTMLElement | null;

const paperSx = {
  mt: 1,
  minWidth: 260,
  borderRadius: 2,
  bgcolor: "text.primary",
  color: "common.white",
};

export default function AccountPopover() {
  const [anchorEl, setAnchorEl] = React.useState<AnchorEl>(null);
  const { isAuthenticated, user } = useAuth0();

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);
  const open = Boolean(anchorEl);
  const id = open ? "account-popover" : undefined;

  return (
    <Box>
      <IconButton
        aria-describedby={id}
        aria-haspopup="menu"
        aria-label="Abrir menú de cuenta"
        onClick={handleOpen}
        size="small"
      >
        {user ? <AccountAvatar picture={user.picture} /> : <AccountAvatar />}
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          paper: {
            sx: paperSx,
          },
        }}
      >
        {isAuthenticated ? <LogoutButton /> : <LoginButton />}
      </Popover>
    </Box>
  );
}
